
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

// ngUpgrade Angular core services module
// Import converted service classes in ./services here
// Add to providers array, below
// Then go back to core.services.module.ajs.ts and register the downgraded service
import { Base64 } from './services/core.base64.service';
import { PermissionsService } from './services/core.permissions.service';
import { SiteConfigService } from './services/core.site-config.service';
import { ServiceResponseProcessor } from './services/core.response-processor.service';
import { StringDiffService } from './services/core.string-diff.service';
import { AssociationRest } from './services/core.association.rest';
import { UserRest } from './services/core.user.rest.service';
import { GroupsHelper } from './services/core.groups.helper';
import { TagsModel } from './services/core.models.tags.component';
import { NotificationService } from './services/core.notification.service';
import { SettingService } from './services/core.setting.service';
import { UtilsService } from './services/core.utils.service';
import { StateStackService } from './services/core.state-stack.service';
import { ConstantsService } from './services/core.constants.service'
import { PollService } from './services/core.poll.service';
import { UiService } from './services/core.ui.service';
import { StateHelperService } from './services/core.ui.state.service';
import { AccessDeniedService } from './services/core.access-denied.service';
import { UserService } from './services/core.user.service';
import { UploadService } from './services/core.upload.service';
import { MonitorService } from './services/core.monitor.service';
import { TokenService } from './services/core.token.service';
import { LegacyKanbanService} from './services/core.legacy-kanban.service';
import { FilterService} from './services/core.filter.service';
import { GfTranslateService} from './services/core.translate.service';
import { ProjectModel } from './services/project.model.service';
import { ProjectService } from './services/project.service';
import { DynamicComponentLoaderService } from './services/core.dynamic.component.loader.service';
import { SearchService } from './services/core.search.service';
import { ReportsDataService } from './services/core.report-data.service';
import { SnapshotService } from './services/core.snapshot.service';
import { AdminService } from './services/core.admin.service';
import { FeatureFlagService } from './services/core.feature-flags.service';
import { MentionsService } from './services/core.mentio.service';
import { DragNotificationService } from './services/core.drag-notification.service';
import { AppInitializationService } from './services/core.app-initialization.service';
import { PageContextService } from './services/core.page-context.service';
import { GfTitleService } from './services/core.title.service';
import { GfMetaService } from './services/core.meta.service';
import { AiFlowService } from './services/core.ai-flow.service';
import { AnalyticsService } from './services/core.analytics.service';
import { EventWebhookService } from './services/core.event-webhook.service';
import { ChatStatusService } from './services/core.chat-status.service';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule
    ],
    providers: [
        Base64,
        PermissionsService,
        SiteConfigService,
        ServiceResponseProcessor,
        StringDiffService,
        AssociationRest,
        UserRest,
        GroupsHelper,
        TagsModel,
        NotificationService,
        SettingService,
        UtilsService,
        StateStackService,
        ConstantsService,
        PollService,
        UiService,
        UserService,
        UploadService,
        MonitorService,
        TokenService,
        LegacyKanbanService,
        FilterService,
        GfTranslateService,
        StateHelperService,
        AccessDeniedService,
        GfTranslateService,
        ProjectService,
        ProjectModel,
        SearchService,
        ReportsDataService,
        SnapshotService,
        DynamicComponentLoaderService,
        AdminService,
        FeatureFlagService,
        MentionsService,
        DragNotificationService,
        AppInitializationService,
        PageContextService,
        GfTitleService,
        { provide: Title, useExisting: GfTitleService },
        GfMetaService,
        AiFlowService,
        AnalyticsService,
        EventWebhookService,
        ChatStatusService,
    ]
})
export class CoreServicesModule {
    constructor() { }
}
